import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';

import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import Header from './Header';

// Layout del panel de administracion (admin/tecnico): sidebar + topbar + contenido
export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Header onOpenMobileNav={() => setMobileOpen(true)} />
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // minWidth: 0 anula el min-width:auto por defecto de los items flex: sin esto,
          // un hijo ancho (p. ej. la tabla de productos) fuerza a toda la pagina a
          // desbordarse en vez de que sea la tabla la que haga su propio scroll interno.
          minWidth: 0,
          width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
          p: { xs: 2, md: 3 },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
